import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ExercisesComponent} from './exercises/exercises.component';
import { TopicComponent } from './topic/topic.component';
import {BubbleSortComponent} from './bubble-sort/bubble-sort.component';
/*import { TeacherGuard } from '../App/teacher-guard.service';
import { TExercisesComponent } from './t-exercises/t-exercises.component';
import { TAllExercisesComponent } from './t-all-exercises/t-all-exercises.component';*/
import {TS} from '@angular/compiler-cli/src/transformers/util';
import {TeacherGuard} from '../App/teacher-guard.service';
import {TExercisesComponent} from './t-exercises/t-exercises.component';
import {TAllExercisesComponent} from './t-all-exercises/t-all-exercises.component';
import {TBubbleSortComponent} from './t-bubble-sort/t-bubble-sort.component';
import {BinarySearchComponent} from './binary-search/binary-search.component';
import {HelpComponent} from './help/help.component';


const dataRepresentationRoutes: Routes = [
  { path: 'sort', component: TopicComponent,
    children : [
      { path: '', component: ExercisesComponent, pathMatch: 'full'},
      { path: 'bubbleSort/:id', component: BubbleSortComponent},
      { path: 'binary-search/:id', component: BinarySearchComponent},
      { path: 'help/:type/:id', component: HelpComponent}
    ] },
  {path: 'teacher/sort', canActivate: [TeacherGuard], canActivateChild: [TeacherGuard], component: TopicComponent,
    children : [
      { path: '', component: TExercisesComponent, pathMatch: 'full'},
      { path: 'allExercisesTeacher', component: TAllExercisesComponent},
      { path: 'bubbleSort', component: TBubbleSortComponent},
      { path: 'bubbleSort/:id', component: TBubbleSortComponent}
    ] }
];

@NgModule({
  imports: [
    RouterModule.forChild(dataRepresentationRoutes)
  ],
  declarations: [],
  exports: [
    RouterModule]
})
export class TopicRoutingModule { }
